import { connect } from 'react-redux';
import StudentGrade from '../../../views/Student/report/StudentGrade.student.view';

export default connect(null, null)(StudentGrade);
